import { render } from "./CreateGameForm.vue?vue&type=template&id=158dd30a&ts=true"
import script from "./CreateGameForm.vue?vue&type=script&lang=ts"
export * from "./CreateGameForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__